import { useState, useEffect } from 'react';

import Modal from "~/components/Modal";
import { getPhotoDesc } from "~/providers/lang";
import { getItemInd } from "~/utils/utils";
import { getLargePhoto } from "~/utils/photo";
import { IPhotoItem } from '~/interfaces';
import { KEYS } from "~/const";

import "./style.less";

interface IModalGallery {
	photo: string;
	source: Array<any>;
	onClose?: () => void;
}

export default function ModalGallery({
	photo = "",
	source = [],
	onClose = () => {},
}: IModalGallery) {
	const [state, setState] = useState(() => {
		const ind = getItemInd(source, (item: IPhotoItem) => item.photo === photo);
		const item = ind === -1 ? null : source[ind];

		return {
			imgLoaded: false,
			ind,
			img: "",
			desc: "",
			...item
				? {
					img: getLargePhoto(item),
					desc: getPhotoDesc(item) || "",
				}
				: {},
		};
	});

	function changePhoto(direction: number) {
		setState(prev => {
			const testInd = prev.ind + direction;
			const len = source.length;
			const newInd = testInd < 0 ? len - 1 : testInd > len - 1 ? 0 : testInd;
			const item = source[newInd];

			return {
				...prev,
				imgLoaded: false,
				ind: newInd,
				img: getLargePhoto(item),
				desc: getPhotoDesc(item) || "",
			};
		});
	}

	function imgOnload() {
		setState(prev => ({
			...prev,
			imgLoaded: true,
		}));
	}

	function handleArrows(event: KeyboardEvent) {
		if (event.key === KEYS.LEFT) {
			changePhoto(-1);
		} else if (event.key === KEYS.RIGHT) {
			changePhoto(1);
		}
	}

	useEffect(() => {
		document.addEventListener('keydown', handleArrows);

		return () => {
			document.removeEventListener('keydown', handleArrows);
		};
	}, []);

	return <Modal onClose={onClose} className="modal-gallery" outsideAreaClose={true}>
		<div className="modal-gallery-photoOverlayPanel left" onClick={() => changePhoto(-1)}>
			<span className="modal-gallery-photoOverlayIcon">{"\u2190"}</span>
		</div>
		<div className="modal-gallery-img-cover">
			<img src={state.img} alt={state.desc} className="galleryPage__photoOverlayImg" onLoad={imgOnload} style={{
				display: state.imgLoaded ? "block" : "none",
			}} />
			{ state.desc && <p className="modal-gallery-desc">{state.desc}</p>}
		</div>
		{ state.imgLoaded ? null : <div className="modal-gallery-photoOverlayLoader"></div> }
		<div className="modal-gallery-photoOverlayPanel right" onClick={() => changePhoto(1)}>
			<span className="modal-gallery-photoOverlayIcon">{"\u2192"}</span>
		</div>
	</Modal>;
}
